import { computed } from 'mobx'
import { Page, ProductsTableEntryDTOInterface, ProductTableEntryDTO } from 'models'
import { OnSelectCallbackParam } from 'react-daterange-picker'
import { BRAND_STORE } from 'store/BrandStore'
import { GENERAL_STORE } from 'store/GeneralStore'
import { PaginationSearchBase } from 'store/PaginationSearchBase'
import { FilterRanges, TriggerSearchFunc } from 'store/PaginationSearchBase/PaginationSearchBase.types'
import { RootStore } from 'store/RootStore'
import { Api } from 'utilities'
import {
  BrandProductsRangeProps,
  BrandProductsSortProps, initialBrandProductsFilter,
  initialBrandProductsPaginationProps, needTimeoutProps,
  ProductsFilterDTO
} from './BrandProductsStore.types'
import moment from 'moment'

export const BRAND_PRODUCTS_STORE = 'BRAND_PRODUCTS_STORE'

export class BrandProductsStore extends PaginationSearchBase<
  BrandProductsSortProps,
  ProductsFilterDTO,
  ProductTableEntryDTO
  > {
  rootStore: RootStore

  constructor (rootStore: RootStore) {
    super(
      initialBrandProductsPaginationProps,
      initialBrandProductsFilter,
      [],
      needTimeoutProps
    )
    this.rootStore = rootStore
  }

  getSearchedProducts: TriggerSearchFunc = (options) => {
    const {
      [GENERAL_STORE]: {
        setLoadingOn,
        setLoadingOff,
        handleApiError
      }
    } = this.rootStore

    setLoadingOn()

    Api
      .post(
        `/brand/${this.brandId
        }/products/all?page=${options?.resetPageNumber ? 0 : this.pagination.page
        }&size=${this.pagination.size
        }&sort=${this.pagination.sortProp},${this.pagination.sortDirection}`,
        this.searchProps
      )
      .then((data: Page<ProductsTableEntryDTOInterface>) => {
        const filterRanges: FilterRanges = {
          [BrandProductsRangeProps.AGREEMENT_BUDGET]: { min: null, max: null }
        }

        this.setSearchResults(data.content.map(p => {
          // calculate filter ranges
          if (!this.areFilterRangesSet) {
            Object.values(p.agreementDTOMap || {})
              .forEach(a => {
                filterRanges[BrandProductsRangeProps.AGREEMENT_BUDGET].min =
                  filterRanges[BrandProductsRangeProps.AGREEMENT_BUDGET].min === null
                    ? a.budgetRemaining
                    : Math.min(
                      a.budgetRemaining,
                      filterRanges[BrandProductsRangeProps.AGREEMENT_BUDGET].min
                    )

                filterRanges[BrandProductsRangeProps.AGREEMENT_BUDGET].max =
                  filterRanges[BrandProductsRangeProps.AGREEMENT_BUDGET].max === null
                    ? a.budgetRemaining
                    : Math.max(
                      a.budgetRemaining,
                      filterRanges[BrandProductsRangeProps.AGREEMENT_BUDGET].max
                    )
              })
          }

          return new ProductTableEntryDTO(p)
        }))

        if (!this.areFilterRangesSet) {
          this.setFilterRanges(filterRanges)
        }

        this.handleSearchResultPaginationProps(data)
        setLoadingOff()
      })
      .catch(handleApiError)

    if (!this.triggerSearch) {
      this.triggerSearch = this.getSearchedProducts
    }
  }

  @computed get brandId (): number {
    return this.rootStore[BRAND_STORE].brandToView.id
  }

  @computed get productsTotalCount (): number {
    return this.rootStore[BRAND_STORE].brandToView.productsCount
  }

  @computed get hasProducts (): boolean {
    return this.rootStore[BRAND_STORE].brandToView.productsCount > 0
  }

  @computed get agreementPeriodFilter (): OnSelectCallbackParam {
    const {
      agreementStart,
      agreementEnd
    } = this.searchProps

    if (agreementStart === null) return null

    return {
      start: moment(agreementStart),
      end: moment(agreementEnd)
    }
  }

  /** Handle sync products */
  handleSyncProducts: any = async () => {
    const {
      [GENERAL_STORE]: {
        handleApiError
      }
    } = this.rootStore
  await Api.post(`/stores/${this.rootStore[BRAND_STORE].brandToView.externalId}/productsFromShopify`, {},"marketPlaceApi").catch(handleApiError)
  return;
  }
}
